"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RWSToolsApiToolDataComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const types_1 = require("../../types");
//@ts-ignore                
let rwsTemplate = T.html `<div class="rws-tools-api-tool-data">
    ${(0, fast_element_1.when)(x => !!x.apiToolData, (0, fast_element_1.html) `
        <div class="endpoint-info">
            <div class="endpoint-top-row">
                ${(0, fast_element_1.when)(x => { var _a; return !!((_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.method); }, (0, fast_element_1.html) `
                    <span class="method-badge ${x => { var _a; return (_a = x.apiToolData.method) === null || _a === void 0 ? void 0 : _a.toLowerCase(); }}">${x => { var _a; return (_a = x.apiToolData.method) === null || _a === void 0 ? void 0 : _a.toUpperCase(); }}</span>
                `)}
                <span class="endpoint-name">${x => { var _a; return (_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.endpointName; }}</span>
            </div>
            ${(0, fast_element_1.when)(x => { var _a; return !!((_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.endpoint); }, (0, fast_element_1.html) `
                <div class="endpoint-url">${x => x.apiToolData.endpoint}</div>
            `)}
        </div>
    `)}
    ${(0, fast_element_1.when)(x => { var _a, _b; return ((_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.requestSent) && ((_b = x.apiToolData) === null || _b === void 0 ? void 0 : _b.responseSuccess); }, (0, fast_element_1.html) `
        <div class="response-badge success">
            <i class="simple-icon-check"></i>
            ${'apiTool.requestSent'.t()}
            ${(0, fast_element_1.when)(x => { var _a; return !!((_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.responseStatus); }, (0, fast_element_1.html) `
                <span class="status-code">${x => x.apiToolData.responseStatus}</span>
            `)}
        </div>
        ${(0, fast_element_1.when)(x => { var _a; return !!((_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.endpoint); }, (0, fast_element_1.html) `
            <div class="called-url"><span class="called-url-label">URL:</span> <code>${x => x.apiToolData.endpoint}</code></div>
        `)}
    `)}

    ${(0, fast_element_1.when)(x => { var _a, _b; return ((_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.requestSent) && ((_b = x.apiToolData) === null || _b === void 0 ? void 0 : _b.responseSuccess) === false; }, (0, fast_element_1.html) `
        <div class="response-badge error">
            <i class="simple-icon-close"></i>
            ${'apiTool.requestFailed'.t()}
            ${(0, fast_element_1.when)(x => { var _a; return !!((_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.responseStatus); }, (0, fast_element_1.html) `
                <span class="status-code">${x => x.apiToolData.responseStatus}</span>
            `)}
        </div>
        ${(0, fast_element_1.when)(x => { var _a; return !!((_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.endpoint); }, (0, fast_element_1.html) `
            <div class="called-url"><span class="called-url-label">URL:</span> <code>${x => x.apiToolData.endpoint}</code></div>
        `)}
    `)}

    ${(0, fast_element_1.when)(x => { var _a, _b; return !((_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.requestSent) && ((_b = x.apiToolData) === null || _b === void 0 ? void 0 : _b.totalCount) > 0; }, (0, fast_element_1.html) `
        <div class="progress-bar-wrap">
            <div class="progress-label">
                <span>${'apiTool.collectingData'.t()}</span>
                <span class="progress-count">${x => x.apiToolData.filledCount}/${x => x.apiToolData.totalCount}</span>
            </div>
            <div class="progress-bar">
                <div class="progress-fill" style="width: ${x => x.getProgressPercent()}%"></div>
            </div>
        </div>
    `)}

    ${(0, fast_element_1.when)(x => { var _a, _b; return ((_b = (_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.length) > 0; }, (0, fast_element_1.html) `
        <div class="fields-container">
            ${(0, fast_element_1.repeat)(x => x.apiToolData.fields, (0, fast_element_1.html) `
                <div class="field-row ${field => field.value ? 'filled' : 'empty'}">
                    <span class="field-name">${field => field.name}</span>
                    <span class="field-value">${field => field.value || '—'}</span>
                </div>
            `)}
        </div>
    `)}

    ${(0, fast_element_1.when)(x => { var _a, _b; return ((_a = x.apiToolData) === null || _a === void 0 ? void 0 : _a.requestSent) && !!((_b = x.apiToolData) === null || _b === void 0 ? void 0 : _b.responseData); }, (0, fast_element_1.html) `
        <div class="response-data">
            <div class="response-data-label">${'apiTool.response'.t()}</div>
            <pre class="response-data-body">${x => x.formatResponseData()}</pre>
        </div>
    `)}

    ${(0, fast_element_1.when)(x => !x.apiToolData, (0, fast_element_1.html) `
        <div class="empty-state">
            <span class="empty-icon">🔌</span>
            <p>${'apiTool.noData'.t()}</p>
        </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rws-tools-api-tool-data {
  border-radius: 12px;
}
.rws-tools-api-tool-data .endpoint-info {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 12px;
  padding: 8px 10px;
  background: var(--bg-secondary, #f8f9fa);
  border: 1px solid var(--border-color-light, #dee2e6);
  border-radius: 6px;
}
.rws-tools-api-tool-data .endpoint-info .method-badge {
  font-family: monospace;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 4px;
  text-transform: uppercase;
  flex-shrink: 0;
}
.rws-tools-api-tool-data .endpoint-info .method-badge.get {
  background: #d1ecf1;
  color: #0c5460;
}
.rws-tools-api-tool-data .endpoint-info .method-badge.post {
  background: #d4edda;
  color: #155724;
}
.rws-tools-api-tool-data .endpoint-info .method-badge.put {
  background: #fff3cd;
  color: #856404;
}
.rws-tools-api-tool-data .endpoint-info .method-badge.patch {
  background: #ffeeba;
  color: #856404;
}
.rws-tools-api-tool-data .endpoint-info .method-badge.delete {
  background: #f8d7da;
  color: #721c24;
}
.rws-tools-api-tool-data .endpoint-info .endpoint-top-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.rws-tools-api-tool-data .endpoint-info .endpoint-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
  word-break: break-word;
}
.rws-tools-api-tool-data .endpoint-info .endpoint-url {
  font-family: monospace;
  font-size: 0.75rem;
  color: var(--text-secondary, #6c757d);
  word-break: break-all;
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px solid var(--border-color-light, #dee2e6);
}
.rws-tools-api-tool-data .response-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 16px;
  padding: 4px 12px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 12px;
}
.rws-tools-api-tool-data .response-badge.success {
  background: var(--success-color-light, #d4edda);
  color: var(--success-color-dark, #155724);
  border: 1px solid var(--success-color, #28a745);
}
.rws-tools-api-tool-data .response-badge.error {
  background: var(--danger-color-light, #f8d7da);
  color: var(--danger-color-dark, #721c24);
  border: 1px solid var(--danger-color, #dc3545);
}
.rws-tools-api-tool-data .response-badge .status-code {
  font-family: monospace;
  font-size: 0.8rem;
  opacity: 0.8;
}
.rws-tools-api-tool-data .called-url {
  font-size: 0.8rem;
  color: var(--text-secondary, #6c757d);
  margin-bottom: 10px;
  word-break: break-all;
}
.rws-tools-api-tool-data .called-url .called-url-label {
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
}
.rws-tools-api-tool-data .called-url code {
  font-family: monospace;
  background: var(--bg-secondary, #f8f9fa);
  padding: 1px 4px;
  border-radius: 3px;
}
.rws-tools-api-tool-data .progress-bar-wrap {
  margin-bottom: 12px;
}
.rws-tools-api-tool-data .progress-bar-wrap .progress-label {
  display: flex;
  justify-content: space-between;
  font-size: 0.82rem;
  color: var(--text-secondary, #6c757d);
  margin-bottom: 4px;
}
.rws-tools-api-tool-data .progress-bar-wrap .progress-label .progress-count {
  font-weight: 600;
}
.rws-tools-api-tool-data .progress-bar-wrap .progress-bar {
  height: 6px;
  background: var(--border-color-light, #dee2e6);
  border-radius: 3px;
  overflow: hidden;
}
.rws-tools-api-tool-data .progress-bar-wrap .progress-bar .progress-fill {
  height: 100%;
  background: var(--primary-color, #007acc);
  border-radius: 3px;
  transition: width 0.3s ease;
}
.rws-tools-api-tool-data .fields-container {
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 8px;
  padding: 16px;
  display: grid;
  gap: 6px;
  margin-bottom: 12px;
}
.rws-tools-api-tool-data .fields-container .field-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: var(--bg-tertiary, #ffffff);
  border: 1px solid var(--border-color-light, #dee2e6);
  border-radius: 6px;
}
.rws-tools-api-tool-data .fields-container .field-row.filled {
  border-left: 3px solid var(--success-color, #28a745);
}
.rws-tools-api-tool-data .fields-container .field-row.empty {
  border-left: 3px solid var(--border-color-light, #dee2e6);
  opacity: 0.7;
}
.rws-tools-api-tool-data .fields-container .field-row .field-name {
  font-weight: 600;
  color: var(--text-secondary, #6c757d);
  font-size: 0.85rem;
}
.rws-tools-api-tool-data .fields-container .field-row .field-value {
  color: var(--text-primary, #1a1a1a);
  font-size: 0.9rem;
  font-weight: 500;
  text-align: right;
  word-break: break-word;
  max-width: 60%;
}
.rws-tools-api-tool-data .response-data {
  margin-top: 8px;
}
.rws-tools-api-tool-data .response-data .response-data-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text-secondary, #6c757d);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 4px;
}
.rws-tools-api-tool-data .response-data .response-data-body {
  background: var(--bg-secondary, #f8f9fa);
  border: 1px solid var(--border-color-light, #dee2e6);
  border-radius: 6px;
  padding: 10px 12px;
  font-family: monospace;
  font-size: 0.8rem;
  color: var(--text-primary, #1a1a1a);
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 200px;
  overflow-y: auto;
  margin: 0;
}
.rws-tools-api-tool-data .empty-state {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-api-tool-data .empty-state .empty-icon {
  font-size: 3rem;
  margin-bottom: 16px;
  display: block;
  opacity: 0.7;
}
.rws-tools-api-tool-data .empty-state p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}
.rws-tools-api-tool-data .empty-state .empty-suggestion {
  color: var(--text-tertiary, #9ca3af);
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 8px;
}
[data-theme=dark] .rws-tools-api-tool-data .tool-container {
  background: var(--bg-secondary-dark, #2d3748);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-list-item {
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-list-item .item-title {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-list-item .item-subtitle {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-list-item .item-description {
  color: var(--text-secondary-dark, #a0aec0);
  border-top-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-list-item:hover {
  background: var(--bg-hover-dark, #4a5568);
  border-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-list-item:hover::after {
  background: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-query-display {
  background: var(--bg-secondary-dark, #2d3748);
  border-left-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-query-display .query-label {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-query-display .query-text {
  color: var(--text-primary-dark, #f7fafc);
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-results-summary {
  background: var(--success-color-dark-bg, #1e4d2b);
  border-color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-results-summary .results-count {
  color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-empty-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-empty-state p {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-empty-state .empty-suggestion {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-loading-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-api-tool-data .tool-loading-state .spinner {
  border-color: var(--border-color-dark, #4a5568);
  border-top-color: var(--primary-color-dark, #63b3ed);
}
@media (max-width: 768px) {
  .rws-tools-api-tool-data {
    padding: 16px;
    margin: 12px 0;
  }
  .rws-tools-api-tool-data h3 {
    font-size: 1.1rem;
  }
  .rws-tools-api-tool-data h4 {
    font-size: 0.95rem;
  }
  .rws-tools-api-tool-data .tool-container {
    padding: 12px;
  }
  .rws-tools-api-tool-data .tool-list-item {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .rws-tools-api-tool-data .tool-list-item .item-title {
    font-size: 0.9rem;
  }
  .rws-tools-api-tool-data .tool-list-item .item-description {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .rws-tools-api-tool-data .tool-empty-state {
    padding: 24px 12px;
  }
  .rws-tools-api-tool-data .tool-empty-state .empty-icon {
    font-size: 2rem;
  }
  .rws-tools-api-tool-data .tool-empty-state p {
    font-size: 0.9rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let RWSToolsApiToolDataComponent = class RWSToolsApiToolDataComponent extends client_1.RWSViewComponent {
    getProgressPercent() {
        var _a;
        if (!((_a = this.apiToolData) === null || _a === void 0 ? void 0 : _a.totalCount)) {
            return 0;
        }
        return Math.round((this.apiToolData.filledCount / this.apiToolData.totalCount) * 100);
    }
    getFieldLabel(name) {
        return name;
    }
    formatResponseData() {
        var _a;
        if (!((_a = this.apiToolData) === null || _a === void 0 ? void 0 : _a.responseData)) {
            return '';
        }
        try {
            return JSON.stringify(this.apiToolData.responseData, null, 2);
        }
        catch (_b) {
            return String(this.apiToolData.responseData);
        }
    }
};
exports.RWSToolsApiToolDataComponent = RWSToolsApiToolDataComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof types_1.ApiToolData !== "undefined" && types_1.ApiToolData) === "function" ? _a : Object)
], RWSToolsApiToolDataComponent.prototype, "apiToolData", void 0);
exports.RWSToolsApiToolDataComponent = RWSToolsApiToolDataComponent = __decorate([
    (0, client_1.RWSView)('rws-tools-api-tool-data', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RWSToolsApiToolDataComponent);
RWSToolsApiToolDataComponent.defineComponent();
